
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import { getExam, save, getview,addCreditParty,addAddress,relation } from '@/api/jfhl.js'
import { updateuser } from '@/api/lottery.js'
import { isAward, isAwardbefore } from '@/api/lottery'
import { getAddressDefault } from '@/api/user'
import { getRequest } from '@/libs/utils.js'
import config from '@/config/index'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton,
Group,
XInput
},
data() {
return {
baseUrl: config.baseUrl,
openbg:openbg,
lotid:0,
examList: {},
subjectid: [],
useroption: [],
multi:[],
partyid:this.$route.params.partyid,
paperInfoid:'',
active: 0, // 当前题数
errorList: [],
dialogText: '您获得一次抽奖机会',
dialogType: '',
btnPre: '上一题',
btnNext: '下一题',
ispre:true,
isnext:true,
showDialog: false,
showErrorList: false,
showAddress:false,
partyuserid:this.$route.params.partyuserid
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
mounted() {
this.view()
},
watch: {





active(newValue,oldValue){
if (newValue === this.examList.length-1) {
this.btnNext = '提交'
}else{
this.btnNext = '下一题'
}
},
multi(newValue,oldValue){
}
},
methods: {

view(){
getview({
id: this.partyid
}).then(res=>{
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.getExam()
})
},
getExam() {
let _this = this
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.$vux.toast.text('您今天的三次答题机会已用完请明天再来')
setTimeout(()=>{ this.$router.push({ name: 'zzwdgIndex',params:{partyid:this.partyid}}) }, 1000)
return false
}
this.examList = data.obj.SUBJECTLIST
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
})
},

viewerrorlist() {
this.showDialog = false
this.showErrorList = true
},

answerNext() {
if (this.active + 1 >= this.examList.length) {
save({
paperInfoid: this.paperInfoid,
subjectid: this.subjectid.join(';'),
useroption: this.useroption.join(';'),
openid: this.accountid,
partyuserid: this.partyuserid
}).then(data => {
if (data.obj.ISTRUE === 1) {
this.showDialog = true
this.dialogText = '恭喜您!<br>获得一次抽奖机会'
this.dialogType = 'success'
} else {
let wt = data.obj.ERRORLIST.length
this.showDialog = true
this.dialogText =
'答对' + (this.examList.length - wt) + '题，答错' + wt + '题'
this.errorList = data.obj.ERRORLIST
this.dialogType = 'fail'
}
})
} else {
this.$set(this.useroption,this.useroption.length,this.multi.join(','))
this.multi = []
if (!this.useroption[this.active]) {
this.$vux.toast.text('请选择答案')
return false
}
this.active++
}
},
answerPre() {
this.active--
},
gorule(){
this.$router.push({ name: 'zzwdgRule',params:{partyid:this.partyid}})
},
goWrong(){
this.showErrorList=false
this.$router.push({ name: 'zzwdgIndex',params:{partyid:this.partyid}})
},
gotolottery() {
this.showDialog = false
this.$router.push({ name: 'zzwdgLottery',params:{partyid:this.partyid,partyuserid:this.partyuserid}})
},
reload() {
this.$router.go(-1)
}
}
}
